import { Badge } from "@/components/ui/badge";
import {
   Dialog,
   DialogContent,
   DialogDescription,
   DialogHeader,
   DialogTitle,
} from "@/components/ui/dialog";
import { format } from 'date-fns';

const HistoryModal = ({ isOpen, onClose, history = [] }) => {
   const getStatusBadgeClass = (status) => {
      const statusClasses = {
         'Draft': 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200',
         'Submitted': 'bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200',
         'In Progress': 'bg-yellow-100 dark:bg-yellow-900/30 text-yellow-800 dark:text-yellow-200',
         'Returned': 'bg-orange-100 dark:bg-orange-900/30 text-orange-800 dark:text-orange-200',
         'Accepted': 'bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200',
         'Released': 'bg-indigo-100 dark:bg-indigo-900/30 text-indigo-800 dark:text-indigo-200',
         'Expired': 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200',
         'Renewed': 'bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-200',
         'Rejected': 'bg-red-100 dark:bg-red-900/30 text-red-800 dark:text-red-200',
      };
      return statusClasses[status] || 'bg-gray-100 dark:bg-gray-800 text-gray-800 dark:text-gray-200';
   };

   const getActionDescription = (entry) => {
      if (entry.stage === 'TechnicalStaffReview' && entry.assignedTechnicalStaffName) {
         return `Assigned to ${entry.assignedTechnicalStaffName}`;
      }
      return entry.notes;
   };

   return (
      <Dialog open={isOpen} onOpenChange={onClose}>
         <DialogContent className="max-w-2xl max-h-[80vh] flex flex-col">
            <DialogHeader>
               <DialogTitle>Application History</DialogTitle>
               <DialogDescription>
                  This is a list of all the stages and statuses that this application has been through.
               </DialogDescription>
            </DialogHeader>
            <div className="h-[400px] overflow-y-auto pr-2 mt-2 [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-thumb]:bg-gray-600 [&::-webkit-scrollbar-thumb]:rounded-full">
               {history.length === 0 ? (
                  <div className="flex flex-col items-center justify-center h-full text-center">
                     <div className="text-gray-400 dark:text-gray-500">
                        <p className="text-lg font-medium">No History Available</p>
                        <p className="text-sm mt-2">This application has no recorded history yet.</p>
                     </div>
                  </div>
               ) : (
                  <div className="space-y-4">
                     {history.map((entry, index) => (
                        <div
                           key={index}
                           className="relative pb-8 last:pb-0"
                        >
                           {/* Timeline connector */}
                           {index !== history.length - 1 && (
                              <div className="absolute left-4 top-4 -bottom-4 w-0.5 bg-gray-200 dark:bg-gray-700" />
                           )}

                           <div className="relative flex items-start space-x-3">
                              {/* Timeline dot */}
                              <div className="relative">
                                 <span className="h-8 w-8 rounded-full bg-gray-200 dark:bg-gray-700 flex items-center justify-center ring-8 ring-white dark:ring-gray-900">
                                    <div className="h-2.5 w-2.5 rounded-full bg-gray-600 dark:bg-gray-300" />
                                 </span>
                              </div>

                              {/* Content */}
                              <div className="flex-grow bg-white dark:bg-gray-800 rounded-lg border dark:border-gray-700 p-4">
                                 <div className="flex items-center justify-between mb-2">
                                    <Badge className={getStatusBadgeClass(entry.status)}>
                                       {entry.status}
                                    </Badge>
                                    <span className="text-sm text-gray-500 dark:text-gray-400">
                                       {format(new Date(parseInt(entry.timestamp)), 'MMM d, yyyy h:mm a')}
                                    </span>
                                 </div>
                                 <div className="text-sm font-medium text-gray-900 dark:text-gray-100 mb-1">
                                    Stage: {entry.stage}
                                 </div>
                                 {entry.assignedTechnicalStaffName && (
                                    <div className="text-sm text-blue-600 dark:text-blue-400 mb-1">
                                       Assigned to: {entry.assignedTechnicalStaffName}
                                    </div>
                                 )}
                                 {entry.notes && (
                                    <p className="text-sm text-gray-600 dark:text-gray-300">
                                       {entry.notes}
                                    </p>
                                 )}
                              </div>
                           </div>
                        </div>
                     ))}
                  </div>
               )}
            </div>
         </DialogContent>
      </Dialog>
   );
};

export default HistoryModal;
